import React, { useState } from "react";
import { Crossfit } from "src/modules/fithub-shared/interfaces/workout";
import MWProps from "../interfaces";

const CrossfitComp: React.FC<MWProps<Crossfit>> = (props) => {
  const [text, setText] = useState(props.content.instructions);

  function onInteract() {
    if (props.content.instructions !== text) {
      props.onChange({ instructions: text });
    }
  }

  return (
    <div className="mb-2.5 flex flex-1 flex-col items-center overflow-hidden">
      <div className="flex w-full flex-1 flex-col items-center p-6">
        <p className="font-bold uppercase">Instruções para Treino</p>
        <div className="flex h-full w-full flex-1 p-2.5">
          <textarea
            className="h-full w-full flex-1 resize-none rounded border border-zinc-600 bg-zinc-100 p-2.5 outline-none"
            placeholder="Digite aqui as informações..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onMouseLeave={onInteract}
            onBlur={onInteract}
          />
        </div>
      </div>
    </div>
  );
};

export default CrossfitComp;
